import { render } from "./UserEmployments.vue?vue&type=template&id=d3f24c26"
import script from "./UserEmployments.vue?vue&type=script&lang=js"
export * from "./UserEmployments.vue?vue&type=script&lang=js"

import exportComponent from "/Users/christianbundgaard/dev/ideal-ventures/ideal-hr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__